export const stringMapDefault = {
    invalidDate: "Invalid Date"
};
